export const ASYNC_NETWORK_ID = '3';



// WEBPACK FOOTER //
// ./src/utils/Constants.js